// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.condition-label {
  display: inline-flex;
  align-items: center;
  background: var(--t-swatches-orange-100);
  color: var(--t-swatches-orange-800);
  border: 1px solid var(--t-swatches-orange-300);
  font-weight: 600;
  font-size: 0.85em;
  padding: 0 4px;
  user-select: none;
  margin-right: 2px;
  cursor: pointer;
}

/*
 * Link state, mirroring the placeholder chips:
 * unconfigured = no question picked yet, broken = the ref resolves to nothing.
 */
.condition-label[data-condition-state='unconfigured'] {
  background: var(--t-semantic-surface-sunken);
  color: var(--t-swatches-gray-700);
  border: 1px dashed var(--t-swatches-gray-400);
}

.condition-label[data-condition-state='broken'] {
  background: var(--t-swatches-red-50);
  color: var(--t-swatches-red-700);
  border: 1px solid var(--t-swatches-red-300);
}

.condition-label--start {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;

  &::before {
    content: '[' attr(data-condition-label);
  }
}

.condition-label--end {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;

  &::before {
    content: attr(data-condition-label) ']';
  }
}
`, "",{"version":3,"sources":["webpack://./shared/domains/pleditor@next/plugins/TemplateEditorPlugins/Conditions/style.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,8CAA8C;EAC9C,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;EAGE;AACF;EACE,4CAA4C;EAC5C,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;;EAE9B;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;;EAE/B;IACE,uCAAuC;EACzC;AACF","sourcesContent":[".condition-label {\n  display: inline-flex;\n  align-items: center;\n  background: var(--t-swatches-orange-100);\n  color: var(--t-swatches-orange-800);\n  border: 1px solid var(--t-swatches-orange-300);\n  font-weight: 600;\n  font-size: 0.85em;\n  padding: 0 4px;\n  user-select: none;\n  margin-right: 2px;\n  cursor: pointer;\n}\n\n/*\n * Link state, mirroring the placeholder chips:\n * unconfigured = no question picked yet, broken = the ref resolves to nothing.\n */\n.condition-label[data-condition-state='unconfigured'] {\n  background: var(--t-semantic-surface-sunken);\n  color: var(--t-swatches-gray-700);\n  border: 1px dashed var(--t-swatches-gray-400);\n}\n\n.condition-label[data-condition-state='broken'] {\n  background: var(--t-swatches-red-50);\n  color: var(--t-swatches-red-700);\n  border: 1px solid var(--t-swatches-red-300);\n}\n\n.condition-label--start {\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n\n  &::before {\n    content: '[' attr(data-condition-label);\n  }\n}\n\n.condition-label--end {\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n\n  &::before {\n    content: attr(data-condition-label) ']';\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
